import iconColor from 'components/iconColor'
import FarClipboard from 'components/Legacy/Icons/FarClipboard'
import { ThemePropsType } from 'components/types'
import { actions } from 'data'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import styled, { css } from 'styled-components'
import { color, px, transition } from 'utils'

type IconProps = { light?: boolean; showSuccess: boolean }
const getColor = (props: IconProps & ThemePropsType) =>
  props.showSuccess
    ? css`
        fill: ${color('blue600')} !important;
      `
    : iconColor(props.light === true ? 'white' : 'dark900')

const Icon = styled.div<IconProps>`
  svg {
    transition: fill ${transition('fast')} ease;
    ${getColor};
  }
`

type Props = {
  className?: string
  customHandler?: () => void
  light?: boolean
  onCopied?: () => void
  value: string
}
const CopyToClipboard = ({ className, customHandler, light, onCopied, value }: Props) => {
  const [showSuccess, setShowState] = useState(false)
  const [timeout, setCopyTimeout] = useState<NodeJS.Timeout>()
  const dispatch = useDispatch()

  const showCopyToast = () => {
    dispatch(
      actions.app.addNotif({
        duration: 2,
        title: 'OK_COPY',
        type: 'success'
      })
    )
  }

  useEffect(() => {
    return function onUnmount() {
      clearTimeout(timeout)
    }
  }, [])

  const handleClick = () => {
    setShowState(true)

    if (customHandler) {
      customHandler()
    }

    if (!document) return

    const temp = document.createElement('textarea')
    temp.value = value || ''
    temp.setAttribute('readonly', '')
    temp.style.position = 'absolute'
    temp.style.left = '-9999px'

    if (document.body) {
      document.body.appendChild(temp)
    }

    temp.select()

    try {
      const res: void | boolean = document.execCommand('copy')

      if (res === true) {
        showCopyToast()
        if (onCopied) {
          onCopied()
        }

        const newTimeout = setTimeout(() => {
          setShowState(false)
        }, 500)
        setCopyTimeout(newTimeout)
      }
    } catch (err) {}

    if (document.body) {
      document.body.removeChild(temp)
    }
  }

  return (
    <Icon className={className} light={light} onClick={handleClick} showSuccess={showSuccess}>
      <FarClipboard selectable size={px('1.25rem')} />
    </Icon>
  )
}

export default CopyToClipboard
